import en from './en';

const ar = {
  ...en,
  language_label: 'اللغة',
  language_english: 'الإنجليزية',
  language_french: 'الفرنسية',
  language_arabic: 'العربية',
  brand_logo_alt: 'شعار AIV',
  member_status_active: 'نشط',
  member_status_inactive: 'غير نشط',
  member_activated: 'تم تفعيل العضو',
  member_deactivated: 'تم إلغاء تفعيل العضو',
  evaluation_delete_confirm: 'هل تريد حذف هذا التقييم؟ لا يمكن التراجع عن هذا الإجراء.',
  equipment_delete_confirm: 'هل أنت متأكد أنك تريد حذف هذه المعدات؟',
  delete_evaluation_failed: 'فشل حذف التقييم',
  delete_equipment_failed: 'فشل حذف المعدات',
  member_remove_confirm: 'هل أنت متأكد أنك تريد إزالة {name}؟',
  weekly_insights_count: '{count} رؤى هذا الأسبوع',
  auth_welcome_back_toast: 'مرحبًا بعودتك!',
  auth_logged_out_inactivity: 'تم تسجيل خروجك بسبب عدم النشاط.',
  forgot_enter_email_reset: 'أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين',
  forgot_reset_link_sent: 'إذا كان البريد الإلكتروني موجودًا، فقد تم إرسال رابط إعادة التعيين',
  forgot_reset_link_failed: 'تعذر إرسال رابط إعادة التعيين',
  insight_weekly_ready: 'رؤيتك الأسبوعية جاهزة.',
  insight_unable_generate: 'يتعذر إنشاء رؤية في الوقت الحالي.',
  insight_already_generated_week: 'تم الإنشاء بالفعل هذا الأسبوع',
  insight_generate_weekly: 'إنشاء الرؤية الأسبوعية',
  club_no_active_selected: 'لم يتم تحديد نادٍ نشط',
  club_updated_simple: 'تم تحديث النادي',
  club_update_failed: 'تعذر تحديث النادي',
  superadmin_failed_load_billing_snapshot: 'فشل تحميل لقطة الفوترة',
  superadmin_failed_load_policies: 'فشل تحميل السياسات',
  superadmin_failed_load_failed_payments: 'فشل تحميل المدفوعات الفاشلة',
  superadmin_policy_title_required: 'عنوان السياسة مطلوب',
  superadmin_draft_saved: 'تم حفظ المسودة',
  superadmin_could_not_save_draft: 'تعذر حفظ المسودة',
  superadmin_version_required: 'الإصدار مطلوب',
  superadmin_policy_published: 'تم نشر السياسة',
  superadmin_could_not_publish_policy: 'تعذر نشر السياسة',
  nav_dashboard: 'لوحة التحكم',
  nav_club: 'النادي',
  nav_leaderboard: 'الترتيب',
  nav_members: 'الأعضاء',
  nav_queue_courts: 'الانتظار والملاعب',
  nav_evaluations: 'التقييمات',
  nav_equipment: 'المعدات',
  nav_match_history: 'سجل المباريات',
  nav_daily_report: 'تقرير المباريات اليومي',
  nav_profile: 'الملف الشخصي',
  nav_theme_app: 'الثيم والتطبيق',
  ui_select_club: 'اختر النادي',
  ui_logout: 'تسجيل الخروج',
  role_admin: 'مدير',
  role_coach: 'مدرب',
  role_player: 'لاعب',
  footer_developed_by: 'تم التطوير بواسطة',
  footer_rights: 'جميع الحقوق محفوظة (c) 2026.',
  login_welcome_back: 'مرحبًا بعودتك',
  login_subtitle: 'أدخل بياناتك للوصول إلى حسابك',
  login_brand_subtitle: 'نادي كرة الريشة',
  login_email: 'البريد الإلكتروني',
  login_password: 'كلمة المرور',
  login_sign_in: 'تسجيل الدخول',
  login_signing_in: 'جارٍ تسجيل الدخول...',
  login_forgot_password: 'هل نسيت كلمة المرور؟',
  login_no_account: 'ليس لديك حساب؟',
  login_create_account: 'إنشاء حساب',
  login_create_one_here: 'أنشئ واحدًا هنا',
  login_choose_continue: 'اختر طريقة المتابعة',
  login_admin_account: 'حساب المدير',
  login_member_account: 'حساب العضو',
  login_verify_sign_in: 'تحقق وسجل الدخول',
  login_verifying_otp: 'جارٍ التحقق من OTP...',
  login_resend_otp: 'إعادة إرسال OTP',
  signup_title: 'أنشئ حسابك',
  signup_subtitle: 'قم بإعداد ناديك وابدأ بإدارة الأعضاء',
  signup_first_name: 'الاسم الأول',
  signup_last_name: 'اسم العائلة',
  signup_email: 'البريد الإلكتروني',
  signup_password: 'كلمة المرور',
  signup_confirm_password: 'تأكيد كلمة المرور',
  signup_required_fields_note: 'الحقول المعلّمة بعلامة * مطلوبة.',
  signup_have_account: 'لديك حساب بالفعل؟',
  signup_sign_in: 'تسجيل الدخول',
  signup_register_club: 'تسجيل النادي',
  signup_email_verification: 'التحقق من البريد الإلكتروني',
  signup_verify_email: 'تحقق من البريد الإلكتروني',
  signup_choose_package: 'اختر باقتك',
  signup_create_admin_account: 'أنشئ حساب مدير النادي للبدء',
  signup_enter_otp_email: 'أدخل رمز OTP المرسل إلى بريدك الإلكتروني',
  signup_pick_plan: 'اختر الخطة المناسبة لناديك',
  signup_step_account: 'الحساب',
  signup_step_verify: 'التحقق',
  signup_step_package: 'الباقة',
  signup_club_details: 'تفاصيل النادي',
  forgot_title: 'إعادة تعيين كلمة المرور',
  forgot_subtitle: 'سنرسل لك رابطًا آمنًا عبر البريد الإلكتروني.',
  forgot_heading: 'نسيت كلمة المرور',
  forgot_description: 'أدخل البريد الإلكتروني المرتبط بحسابك.',
  forgot_check_inbox: 'تحقق من بريدك الوارد',
  forgot_send_link: 'إرسال رابط إعادة التعيين',
  forgot_sending_link: 'جارٍ إرسال الرابط...',
  forgot_back_login: 'العودة إلى تسجيل الدخول',
  forgot_need_help: 'هل تحتاج إلى مساعدة؟ تواصل مع مدير النادي.',
  first_login_setup_subtitle: 'قم بإعداد كلمة المرور للبدء',
  first_login_title: 'أنشئ كلمة المرور',
  first_login_desc: 'اختر كلمة مرور آمنة',
  first_login_new_password: 'كلمة المرور الجديدة',
  first_login_confirm_password: 'تأكيد كلمة المرور',
  first_login_set_continue: 'تعيين كلمة المرور والمتابعة',
  first_login_setting_password: 'جارٍ تعيين كلمة المرور...',
  first_login_go_login: 'الذهاب إلى تسجيل الدخول',
  first_login_agree_privacy: 'أوافق على',
  first_login_agree_terms: 'أوافق على',
  first_login_at_least_8: '8 أحرف على الأقل',
  first_login_at_least_1_upper: 'حرف كبير واحد على الأقل',
  first_login_at_least_1_lower: 'حرف صغير واحد على الأقل',
  first_login_at_least_1_number: 'رقم واحد على الأقل',
  first_login_at_least_1_special: 'رمز خاص واحد على الأقل',
  select_club_title: 'اختر ناديًا',
  select_club_subtitle: 'اختر النادي الذي تريد إدارته أو اللعب فيه',
  select_club_loading: 'جارٍ تحميل الأندية...',
  select_club_entering: 'جارٍ دخول النادي...',
  select_club_none: 'أنت لست عضوًا في أي نادٍ بعد.',
  select_club_no_slogan: 'لا يوجد شعار',
  select_club_enter: 'دخول',
  privacy_notice: 'إشعار خصوصية أونتاريو',
  privacy_title: 'سياسة الخصوصية',
  terms_notice: 'الشروط القانونية',
  terms_title: 'الشروط والأحكام',
  policy_effective_date: 'تاريخ السريان',
  policy_version: 'الإصدار',
  policy_read_terms: 'اقرأ الشروط والأحكام',
  policy_view_privacy: 'اعرض سياسة الخصوصية',
  common_go_back: 'رجوع',
  common_back: 'رجوع',
  common_cancel: 'إلغاء',
  common_loading: 'جارٍ التحميل...',
  common_processing: 'جارٍ المعالجة...',
  common_remove: 'إزالة',
  common_removing: 'جارٍ الإزالة...',
  common_finish: 'إنهاء',
  common_finishing: 'جارٍ الإنهاء...',
  common_error_occurred: 'حدث خطأ',
  common_save: 'حفظ',
  common_save_apply: 'حفظ وتطبيق',
  common_prev: 'السابق',
  common_next: 'التالي',
  common_page: 'الصفحة',
  settings_title: 'الإعدادات',
  settings_manage_subtitle: 'إدارة إعدادات التطبيق',
  settings_theme_app_title: 'إعدادات الثيم والتطبيق',
  settings_theme_app_desc: 'خصص مظهر القائمة ووضع الثيم والخط واللغة',
  settings_theme_mode: 'وضع الثيم',
  settings_light: 'فاتح',
  settings_dark: 'داكن',
  settings_disabled: 'معطل',
  settings_menu_bg: 'لون خلفية القائمة',
  settings_menu_font: 'خط القائمة',
  settings_app_font: 'خط التطبيق',
  package_label_elite: 'إيليت (الباقة 3)',
  package_label_pro: 'برو (الباقة 2)',
  package_label_starter: 'ستارتر (الباقة 1)',
  pkg_name_starter: 'ستارتر',
  pkg_name_pro: 'برو',
  pkg_name_elite: 'إيليت',
  pkg_tier_1: 'الباقة 1',
  pkg_tier_2: 'الباقة 2',
  pkg_tier_3: 'الباقة 3',
  pkg_feature_everything_pro: 'كل ما في برو',
  pkg_feature_everything_starter: 'كل ما في ستارتر',
  pkg_feature_250_members: 'حتى 250 عضوًا نشطًا',
  pkg_feature_150_members: 'حتى 150 عضوًا نشطًا',
  pkg_feature_50_members: 'حتى 50 عضوًا نشطًا',
  pkg_feature_multi_admin: 'صلاحيات وأدوار متقدمة (عدة مديري نادي)',
  pkg_feature_ui_branding: 'عناصر تحكم متقدمة في الواجهة (ألوان وخطوط للنادي)',
  pkg_feature_logo: 'رفع وإدارة شعار النادي',
  pkg_feature_avatar: 'اختيار الصورة الشخصية للأعضاء',
  pkg_feature_ai_chat: 'دردشة ذكاء اصطناعي لتحليلات سجل المباريات',
  pkg_feature_dashboard_insights: 'رؤى أداء عملية في لوحة التحكم',
  pkg_feature_coach_eval: 'تقييمات المدربين',
  pkg_feature_equipment: 'تتبع المعدات',
  pkg_feature_ml_limited: 'تحليلات محدودة بمساعدة ML للاتجاهات الرئيسية',
  pkg_feature_daily_advanced: 'تقارير يومية للمباريات واتجاهات متقدمة للترتيب',
  pkg_feature_member_mgmt: 'إدارة الأعضاء',
  pkg_feature_queue_courts: 'إدارة الانتظار وتوزيع الملاعب',
  pkg_feature_basic_leaderboard: 'سجل المباريات والترتيب الأساسي',
  pkg_feature_basic_dashboard: 'لوحة تحكم أساسية للمدير',
  pkg_gate_upgrade_plan: 'قم بترقية باقتك',
  pkg_gate_unlock: 'افتح',
  pkg_gate_unavailable: 'هذه الميزة غير متاحة في باقتك الحالية.',
  pkg_gate_current_plan: 'باقتك الحالية',
  pkg_gate_upgrade_button: 'ترقية الباقة',
  pkg_gate_elite_only: 'هذه الميزة متاحة فقط في إيليت (الباقة 3).',
  pkg_gate_available_on: 'هذه الميزة متاحة في برو (الباقة 2) وإيليت (الباقة 3).',
  pkg_gate_contact_admin: 'يرجى التواصل مع مدير النادي لترقية الباقة وفتح هذه الميزة.',
  pkg_page_title: 'الباقات',
  pkg_page_subtitle: 'قارن بين جميع الباقات واعرف الباقة النشطة لناديك.',
  pkg_current: 'الحالية',
  pkg_current_plan: 'الباقة الحالية',
  pkg_manage_subscription: 'إدارة الاشتراك',
  pkg_contact_admin: 'التواصل مع المدير',
  pkg_month: 'شهر',
  pkg_year: 'سنة',
  pkg_yearly_savings: 'توفير سنوي',
  pkg_manage_current_plan: 'إدارة الباقة الحالية',
  pkg_upgrade_to_this: 'الترقية إلى هذه الباقة',
  pkg_contact_admin_changes: 'تواصل مع مدير النادي لتغيير الباقة.',
  pkg_need_billing_controls: 'هل تحتاج إلى أدوات الفوترة؟ افتح',
  pkg_billing_admin_only: 'أدوات الفوترة متاحة فقط لمديري النادي.',
  pkg_upgrade_request_subject: 'طلب ترقية الباقة',
  leaderboard_empty_no_matches: 'لا توجد مباريات مكتملة بعد لإنشاء الترتيب.',
  leaderboard_empty_search: 'لا يوجد لاعب يطابق البحث.',
  leaderboard_insights_title: 'رؤى الترتيب',
  leaderboard_insights_availability: 'رؤى الترتيب المتقدمة متاحة في برو (الباقة 2) وإيليت (الباقة 3).',
  leaderboard_insights_contact_admin: 'يرجى التواصل مع مدير النادي لترقية الباقة وفتح رؤى الترتيب هذه.',
  leaderboard_select_club: 'اختر ناديًا لعرض الترتيب.',
  leaderboard_search_placeholder: 'ابحث باسم اللاعب',
  leaderboard_subtitle: 'يعتمد الترتيب على التقييم (التقييم + أداء المباريات).',
  leaderboard_rating: 'التقييم',
  leaderboard_games: 'المباريات',
  profile_2fa_enabled_label: 'مفعل (مطلوب OTP عبر البريد الإلكتروني عند تسجيل الدخول)',
  profile_evaluations_unavailable_starter: 'التقييمات غير متاحة في ستارتر (الباقة 1)',
  profile_upgrade_pro_elite_evaluations: 'قم بالترقية إلى برو أو إيليت لعرض سجل التقييمات ودرجات الفئات.',
  profile_change_package_from_club_settings: 'يمكنك تغيير الباقة من إعدادات النادي.',
  members_capacity_updated: 'تم تحديث الأعضاء النشطين ليتوافقوا مع حد باقتك.',
  members_capacity_exceed_intro: 'يتجاوز عدد الأعضاء النشطين حد باقتك. احتفظ بما يصل إلى',
  members_capacity_active_members_for: 'أعضاء نشطين لباقة',
  members_select_active_title: 'حدد الأعضاء النشطين',
  members_select_active_desc: 'تسمح باقتك الحالية بما يصل إلى {{limit}} أعضاء نشطين. حدد من يجب أن يبقى نشطًا.',
  members_capacity_selected: 'المحدد',
  members_capacity_current_active: 'النشط حاليًا',
  members_applying: 'جارٍ التطبيق...',
  members_apply_selection: 'تطبيق التحديد',
  common_close: 'إغلاق',
  queue_search_members: 'ابحث عن الأعضاء...',
  queue_time_elapsed: 'الوقت المنقضي:',
  queue_time_in_queue: 'الوقت في قائمة الانتظار:',
  queue_clear_title: 'مسح قائمة الانتظار؟',
  queue_shuffle_title: 'خلط قائمة الانتظار؟',
  queue_clear_desc: 'سيؤدي هذا إلى إزالة جميع اللاعبين من قائمة الانتظار. هل أنت متأكد أنك تريد إعادة تعيين القائمة؟',
  queue_shuffle_desc: 'سيؤدي هذا إلى خلط ترتيب قائمة الانتظار الحالي. هل أنت متأكد أنك تريد خلط القائمة؟',
  queue_yes_continue: 'نعم، متابعة',
  queue_add_to_queue: 'إضافة إلى قائمة الانتظار',
  queue_no_players_match_search: 'لا يوجد لاعبون يطابقون البحث.',
  queue_no_players_in_queue: 'لا يوجد لاعبون في قائمة الانتظار.',
  queue_no_members_match_search: 'لا يوجد أعضاء يطابقون البحث.',
  queue_no_members_available_to_add: 'لا يوجد أعضاء متاحون للإضافة.',
  queue_full_limit: 'قائمة الانتظار ممتلئة (الحد: {{limit}}).',
  queue_available: 'متاح',
  queue_in_progress: 'قيد اللعب',
  queue_coach: 'مدرب',
  queue_admin: 'مدير',
  queue_no_prior_head_to_head: 'لا يوجد سجل مواجهات سابق',
  queue_head_to_head_summary: '{{winners}} فازوا بنسبة {{pct}}% ({{wins}}/{{total}}) من المرات ضد {{losers}}',
  queue_remove_from_queue_title: 'إزالة من قائمة الانتظار؟',
  queue_remove_from_queue_desc: 'أنت على وشك إزالة {{name}} من قائمة الانتظار. هل تريد المتابعة؟',
  match_history_view_all_shown: 'عرض جميع المباريات المكتملة ({{total}} معروضة)',
  match_history_view_yours_shown: 'عرض مبارياتك المكتملة ({{total}} معروضة)',
  members_import_csv_help_prefix: 'ارفع ملف CSV بهذه الأعمدة:',
  club_logo_locked_until_edit: 'الشعار مقفل حتى تقوم بتعديل النادي',
  queue_match_notes_placeholder: 'أضف ملاحظات حول المباراة...',
  leaderboard_won: 'فاز',
  leaderboard_lost: 'خسر',
  leaderboard_points_earned: 'النقاط المسجلة',
  leaderboard_points_lost: 'النقاط المستقبلة',
  leaderboard_pd: 'فارق النقاط (PD)',
  leaderboard_rank: 'الترتيب',
  leaderboard_player: 'اللاعب',
  leaderboard_points: 'النقاط',
  leaderboard_scored: 'سجل',
  leaderboard_against: 'ضد',
  leaderboard_you: 'أنت',
  dashboard_eval_analytics: 'تحليلات التقييم',
  dashboard_rank_analytics: 'تحليلات الترتيب',
  dashboard_profile_analytics: 'تحليلات الملف الشخصي',
  dashboard_visual_unavailable: 'العرض المرئي غير متاح',
  dashboard_locked_in_starter: 'مقفلة في ستارتر',
  dashboard_current_plan: 'الباقة الحالية',
  dashboard_available_in_pro_elite: 'متاح في برو وإيليت',
  dashboard_eval_progress: 'تقدم التقييم عبر الوقت',
  dashboard_eval_hint: 'تابع اتجاهات التقييم عند إضافة تقييمات جديدة.',
  dashboard_eval_progress_tooltip: 'يوضح خط المتوسط الاتجاه العام للتقييمات. بدّل الفئات للتركيز على نقاط القوة أو جوانب التحسين.',
  dashboard_average: 'المتوسط',
  dashboard_technical: 'تقني',
  dashboard_movement: 'الحركة',
  dashboard_tactical: 'تكتيكي',
  dashboard_physical: 'بدني',
  dashboard_psychological: 'نفسي',
  dashboard_waiting_for_evaluations: 'بانتظار التقييمات.',
  dashboard_club_matches: 'مباريات النادي',
  dashboard_completed_matches_selected_club: 'المباريات المكتملة في النادي المحدد',
  dashboard_avg_matches_per_court_day: 'متوسط المباريات لكل ملعب / يوم',
  dashboard_avg_active_courts_day: 'متوسط الملاعب النشطة / يوم',
  dashboard_completed_matches_divided_by_courts: 'المباريات المكتملة مقسومة على عدد الملاعب خلال أيام النشاط',
  dashboard_avg_queue_wait_min: 'متوسط الانتظار في القائمة (دقيقة)',
  dashboard_from_club_queue_sessions: 'من جلسات قائمة انتظار النادي',
  dashboard_avg_match_duration: 'متوسط مدة المباراة',
  dashboard_average_duration_completed_club_matches: 'متوسط مدة مباريات النادي المكتملة',
  dashboard_my_matches_today: 'مبارياتي اليوم',
  dashboard_queue_status: 'حالة قائمة الانتظار',
  dashboard_total_members: 'إجمالي الأعضاء',
  dashboard_no_active_matches_now: 'لا توجد مباريات نشطة الآن.',
  dashboard_matches_played_today: 'المباريات التي لُعبت اليوم',
  dashboard_wins_losses_by_day: 'الانتصارات والخسائر حسب اليوم',
  dashboard_wins_losses_tooltip: 'يعرض نتائج مبارياتك اليومية خلال الفترة المحددة.',
  dashboard_points_scored_vs_lost_day: 'النقاط المسجلة مقابل المستقبلة حسب اليوم',
  dashboard_points_chart_tooltip: 'النقاط المسجلة والمستقبلة يوميًا خلال الفترة المحددة.',
  dashboard_no_completed_matches_chart: 'لا توجد مباريات مكتملة لعرضها في الرسم البياني بعد.',
  dashboard_no_leaderboard_history: 'لا يوجد سجل ترتيب حتى الآن.',
  dashboard_not_enough_match_data_pie: 'لا توجد بيانات مباريات كافية للرسم الدائري.',
  dashboard_evaluation_data_unavailable: 'بيانات التقييم غير متاحة بعد.',
  dashboard_queue_history_unavailable: 'سجل قائمة الانتظار غير متاح بعد.',
  dashboard_no_completed_matches_heatmap: 'لا توجد مباريات مكتملة لإنشاء الخريطة الحرارية.',
  dashboard_7d_avg: 'متوسط 7 أيام',
  dashboard_rank_last_days: 'ترتيبك في التصنيف (آخر {{days}} يومًا)',
  dashboard_rank_tooltip: 'موقعك في الترتيب بناءً على التقييمات ونتائج المباريات خلال الفترة المحددة.',
  dashboard_rank_30d: 'ترتيبك في التصنيف (30 يومًا)',
  dashboard_rank_hint: 'شاهد كيف يتحرك ترتيبك مع مرور الوقت بعد تسجيل المباريات.',
  dashboard_club_matches_by_selection_mode: 'مباريات النادي حسب أسلوب الاختيار (آخر {{days}} يومًا)',
  dashboard_selection_mode_tooltip: 'نسبة المباريات حسب آلية الاختيار خلال نفس فترة الرسم البياني.',
  dashboard_my_evaluation_profile: 'ملف تقييمي الشخصي',
  dashboard_evaluation_profile_tooltip: 'يعرض متوسط درجاتك حسب فئة التقييم.',
  dashboard_profile_hint: 'اعرض ملف مهاراتك حسب الفئات وحدد نقاط القوة ومجالات التحسين.',
  dashboard_queue_wait_distribution: 'توزيع وقت الانتظار في القائمة',
  dashboard_queue_distribution_tooltip: 'توزيع مدد جلسات قائمة الانتظار ضمن فئات زمن الانتظار.',
  dashboard_queue_sessions: 'جلسات قائمة الانتظار',
  dashboard_court_usage_day_of_week: 'استخدام الملاعب حسب يوم الأسبوع',
  dashboard_court_usage_tooltip: 'تعرض كل خانة عدد المباريات المكتملة التي لُعبت على ملعب في يوم من الأسبوع.',
  dashboard_court: 'الملعب',
  dashboard_court_number: 'الملعب {{court}}',
  dashboard_court_match_count_title: 'الملعب {{court}} {{day}}: {{count}} {{matchWord}}',
  dashboard_match_singular: 'مباراة',
  dashboard_match_plural: 'مباريات',
  dashboard_price_label: 'السعر',
  queue_need_more_players: 'هناك حاجة إلى {{count}} لاعبين إضافيين في قائمة الانتظار',
  signup_otp_code: 'رمز OTP',
  signup_otp_verified: 'تم التحقق من OTP',
  signup_resend_code: 'إعادة إرسال الرمز',
  signup_resend_in: 'إعادة الإرسال خلال',
  signup_change_email: 'تغيير البريد الإلكتروني',
  signup_continue: 'متابعة',
  signup_first_last_required: 'الاسم الأول واسم العائلة مطلوبان',
  signup_club_required: 'اسم النادي مطلوب',
  signup_select_sport_required: 'يرجى اختيار نوع الرياضة',
  signup_email_required: 'البريد الإلكتروني مطلوب',
  signup_passwords_mismatch: 'كلمتا المرور غير متطابقتين',
  signup_password_requirements: 'يجب أن تستوفي كلمة المرور جميع المتطلبات',
  signup_accept_required: 'يرجى الموافقة على سياسة الخصوصية والشروط والأحكام للمتابعة',
  signup_otp_sent: 'تم إرسال OTP إلى بريدك الإلكتروني',
  signup_otp_send_failed: 'تعذر إرسال OTP',
  signup_otp_session_missing: 'جلسة OTP مفقودة. يرجى إعادة إرسال OTP.',
  signup_enter_otp: 'أدخل OTP',
  signup_otp_verification_failed: 'فشل التحقق من OTP',
  signup_email_verified_continue: 'تم التحقق من البريد الإلكتروني. اضغط متابعة للمتابعة.',
  signup_verify_email_first: 'يرجى التحقق من بريدك الإلكتروني أولاً',
  signup_account_created_login: 'تم إنشاء الحساب. يرجى تسجيل الدخول للمتابعة.',
  signup_failed: 'فشل إنشاء الحساب',
  signup_creating_account: 'جارٍ إنشاء الحساب...',
  signup_create_account: 'إنشاء الحساب',
  auth_account_setup_required: 'إعداد الحساب مطلوب',
  auth_password_reset_required: 'إعادة تعيين كلمة المرور مطلوبة',
  auth_first_time_link_sent: 'لقد أرسلنا رابط الإعداد لأول مرة إلى',
  auth_finish_setup_before_signin: 'افتح ذلك البريد وأكمل تعيين كلمة المرور قبل تسجيل الدخول.',
  auth_password_expired_use_reset: 'انتهت صلاحية كلمة المرور الخاصة بك. استخدم رابط إعادة التعيين المرسل إلى',
  auth_password_expired_suffix: 'لتعيين كلمة مرور جديدة.',
  auth_request_new_reset_link: 'اطلب رابط إعادة تعيين جديد',
  auth_2fa_enabled: 'تم تفعيل المصادقة الثنائية لهذا الحساب.',
  auth_enter_otp_sent_to: 'أدخل رمز OTP المرسل إلى',
  auth_otp_code: 'رمز OTP',
  auth_enter_code: 'أدخل الرمز',
  auth_2fa_session_expired: 'انتهت جلسة المصادقة الثنائية. يرجى تسجيل الدخول مرة أخرى.',
  auth_enter_otp_prompt: 'أدخل رمز OTP المرسل إلى بريدك الإلكتروني',
  auth_otp_failed: 'فشل التحقق من OTP',
  auth_select_account_continue: 'اختر الحساب الذي تريد المتابعة به',
  auth_no_usable_accounts: 'لم يتم العثور على حسابات قابلة للاستخدام',
  auth_first_login_check_email: 'تحقق من بريدك الإلكتروني للحصول على رابط الإعداد الأول لتعيين كلمة المرور.',
  auth_reset_required_info: 'انتهت صلاحية كلمة المرور. اطلب رابط إعادة تعيين للمتابعة.',
  auth_enter_otp_to_complete: 'أدخل رمز OTP المرسل إلى بريدك الإلكتروني لإكمال تسجيل الدخول.',
  auth_login_failed: 'فشل تسجيل الدخول',
  auth_resend_otp_failed: 'تعذر إعادة إرسال OTP',
  auth_otp_resent: 'تمت إعادة إرسال OTP إلى بريدك الإلكتروني.',
  auth_not_in_club_yet: 'أنت لست في أي نادٍ بعد. اطلب من مديرك إرسال دعوة.',
  auth_continue_account_failed: 'تعذر المتابعة بهذا الحساب',
  auth_session_expired_signin_again: 'انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.',
  auth_session_refresh_failed: 'فشل تحديث الجلسة. يرجى تسجيل الدخول مرة أخرى.',
  auth_consent_saved: 'شكرًا. تم تسجيل الموافقة.',
  auth_consent_save_failed: 'تعذر حفظ موافقتك',
  auth_accept_both_policies: 'يرجى قبول كلتا السياستين للمتابعة',
  consent_before_continue: 'قبل المتابعة',
  consent_review_accept_both: 'يرجى مراجعة وقبول كلتا السياستين للوصول إلى التطبيق.',
  consent_accept_continue: 'قبول ومتابعة',
  consent_saving: 'جارٍ الحفظ...',
  first_login_expired_link: 'انتهت صلاحية رابط الدخول لأول مرة. يرجى التواصل مع مدير النادي لطلب دعوة جديدة.',
  first_login_invalid_token_generic: 'رمز غير صالح. يرجى التواصل مع المدير.',
  first_login_password_mismatch: 'كلمتا المرور غير متطابقتين',
  first_login_password_requirements: 'يجب أن تستوفي كلمة المرور جميع المتطلبات',
  first_login_accept_required: 'يرجى الموافقة على سياسة الخصوصية والشروط والأحكام للمتابعة',
  landing_nav_features: 'المزايا',
  landing_nav_showcase: 'العروض',
  landing_nav_pricing: 'الأسعار',
  landing_nav_contact: 'تواصل معنا',
  landing_brand_subtitle: 'ذكاء رياضات المضرب',
  landing_login: 'تسجيل الدخول',
  landing_start_free: 'ابدأ مجانًا',
  landing_hero_member_eyebrow: 'إدارة الأعضاء',
  landing_hero_member_title: 'اجمع كل لاعب ومدرب ومدير في نظام نادي واحد منظم.',
  landing_hero_member_desc: 'أدر الدعوات والاستيراد الجماعي والتحكم في الوصول وإعداد أول تسجيل دخول من خلال مسار أعضاء مصمم لأندية رياضات المضرب الحديثة.',
  landing_hero_create_club: 'أنشئ ناديك',
  landing_hero_see_pricing: 'شاهد الأسعار',
  landing_hero_stats_eyebrow: 'الإحصاءات والترتيب',
  landing_hero_stats_title: 'حوّل نشاط النادي اليومي إلى تقارير وترتيب ورؤى أداء قابلة للاستخدام.',
  landing_hero_stats_desc: 'تابع حركة الترتيب وسجل المباريات والتقييمات والتقارير اليومية والتحليلات من خلال عرض أداء واضح.',
  landing_hero_explore_features: 'استكشف المزايا',
  landing_hero_watch_demo: 'شاهد العرض',
  landing_hero_queue_eyebrow: 'الانتظار والتحكم في المباريات',
  landing_hero_queue_title: 'أدر تدفق قائمة الانتظار وتوزيع الملاعب وتشغيل المباريات من شاشة واحدة مباشرة.',
  landing_hero_queue_desc: 'حافظ على سلاسة الجلسات من خلال أوضاع توزيع متعددة ورؤية مباشرة لقائمة الانتظار وتدوير متوازن وسير عمل واضح لإنهاء المباريات.',
  landing_hero_compare_packages: 'قارن الباقات',
  landing_hero_contact_us: 'تواصل معنا',
  landing_hero_go_to_slide: 'اذهب إلى الشريحة',
  landing_hero_prev_slide: 'الشريحة السابقة',
  landing_hero_next_slide: 'الشريحة التالية',
  landing_hero_pause: 'إيقاف العرض التلقائي',
  landing_hero_play: 'تشغيل العرض التلقائي',
  landing_features_badge: 'المزايا الأساسية',
  landing_features_title: 'كل ما يحتاجه ناديك',
  landing_features_desc: 'مصمم خصيصًا لأندية رياضات المضرب، من إدارة الأعضاء إلى تحليلات المباريات.',
  landing_feature_members_title: 'إدارة الأعضاء',
  landing_feature_members_text: 'اجمع اللاعبين والمدربين والمديرين في نظام أعضاء منظم مع تسجيل سلس وصلاحيات واضحة وهيكل يتوسع مع نمو ناديك.',
  landing_feature_members_bullet_1: 'إضافة فردية واستيراد جماعي للأعضاء',
  landing_feature_members_bullet_2: 'إدارة الأدوار والصلاحيات',
  landing_feature_members_bullet_3: 'مسار دعوة أول تسجيل دخول',
  landing_feature_queue_title: 'الانتظار والملاعب',
  landing_feature_queue_text: 'أدر حركة قائمة الانتظار وتوزيع الملاعب من واجهة مباشرة واحدة مصممة للجلسات المزدحمة والتدوير المتوازن وتشغيل المباريات بسلاسة.',
  landing_feature_queue_bullet_1: 'رؤية مباشرة لقائمة الانتظار',
  landing_feature_queue_bullet_2: 'أوضاع متعددة لتوزيع الملاعب',
  landing_feature_queue_bullet_3: 'إنهاء المباراة وتحديث قائمة الانتظار تلقائيًا',
  landing_feature_stats_title: 'الإحصاءات والرؤى',
  landing_feature_stats_text: 'حوّل نشاط النادي إلى رؤية واضحة للأداء من خلال سجل المباريات وحركة الترتيب والتقارير والتقييمات والرؤى المقدمة بالذكاء الاصطناعي والقابلة للتنفيذ.',
  landing_feature_stats_bullet_1: 'متابعة الترتيب وسجل المباريات',
  landing_feature_stats_bullet_2: 'تقارير يومية ورؤى أسبوعية',
  landing_feature_stats_bullet_3: 'تحليلات الأداء والتقييم',
  landing_benefits_badge: 'لماذا نحن',
  landing_benefits_title: 'مصمم لأندية رياضات المضرب الحديثة',
  landing_benefits_desc: 'نظام تشغيل مركز للأندية التي تحتاج إلى هيكل وسرعة وتحكم أفضل في الأعضاء والملاعب والمباريات والتقارير.',
  landing_benefit_1_title: 'مصمم للجلسات المباشرة',
  landing_benefit_1_text: 'حافظ على حركة الأعضاء والانتظار والملاعب والمباريات بدون تعطيل تشغيلي.',
  landing_benefit_2_title: 'مبني لواقع عمل النادي',
  landing_benefit_2_text: 'مبني حول طريقة العمل اليومية الفعلية، مع أدوات تدعم التنسيق والتشغيل بدل التعقيد الإداري العام.',
  landing_benefit_3_title: 'جاهز للتشغيل اليومي',
  landing_benefit_3_text: 'ادعم الإضافة وإدارة المباريات والتقارير ومراجعة الأداء من خلال منصة واحدة موثوقة.',
  landing_showcase_badge: 'العروض',
  landing_showcase_title: 'شاهد Smashlytics أثناء العمل',
  landing_showcase_desc: 'اكتشف كيف تحول المنصة إدارة النادي من خلال مسارات عمل واضحة وعملية.',
  landing_showcase_1_title: 'إنشاء النادي وإدارته',
  landing_showcase_1_text: 'أنشئ ناديًا وحدّث التفاصيل الأساسية واضبط الملاعب والجداول وأبقِ الإعدادات التشغيلية متناسقة منذ اليوم الأول.',
  landing_showcase_2_title: 'إدارة الأعضاء',
  landing_showcase_2_text: 'أضف الأعضاء فرديًا أو جماعيًا وأدر الأدوار وعدّل الملفات الشخصية وحافظ على قائمة أعضاء منظمة.',
  landing_showcase_3_title: 'الانتظار والملاعب والمباريات',
  landing_showcase_3_text: 'أدر تدفق الانتظار المباشر ووزع الملاعب ووازن الجلسات وأنهِ المباريات من خلال مسار تحكم واضح.',
  landing_showcase_4_title: 'التقييمات',
  landing_showcase_4_text: 'أضف تقييمات اللاعبين وعدّلها وتابع فئات التقييم واحتفظ بتغذية راجعة منظمة وقابلة للمراجعة.',
  landing_showcase_5_title: 'سجل المباريات والتقارير اليومية',
  landing_showcase_5_text: 'راجع المباريات المكتملة والملخصات اليومية وواجهات التقارير التي تساعد النادي على فهم نشاط الجلسات بوضوح.',
  landing_showcase_6_title: 'إدارة الملف الشخصي',
  landing_showcase_6_text: 'حدّث بيانات الملف الشخصي والتفضيلات والمعلومات الظاهرة للأعضاء من خلال مسار ملف شخصي واضح.',
  landing_showcase_7_title: 'إدارة المعدات',
  landing_showcase_7_text: 'أدر معدات النادي ونظم سجلات الأدوات واربط استخدام المعدات عند إنهاء المباريات.',
  landing_showcase_8_title: 'الثيم والهوية واللغة',
  landing_showcase_8_text: 'خصص مظهر النادي وأدر إعدادات الثيم وبدّل لغة المنصة بما يتناسب مع طريقة عمل ناديك.',
  landing_open_walkthrough: 'افتح الشرح',
  landing_watch_demo: 'شاهد العرض',
  landing_pricing_badge: 'الأسعار',
  landing_pricing_title: 'اختر باقتك',
  landing_pricing_desc: 'اختر الخطة المناسبة لاحتياجات ناديك ووسّعها مع نمو النادي.',
  landing_pricing_most_popular: 'الأكثر شيوعًا',
  landing_pricing_save_yearly: 'وفّر {{pct}}% مع الفوترة السنوية',
  landing_pricing_choose_plan: 'اختر {{name}}',
  landing_pricing_starter_desc: 'للأندية التي تحتاج إلى أساس تشغيلي واضح.',
  landing_pricing_pro_desc: 'للأندية المستقرة التي تريد رؤية أعمق للأداء.',
  landing_pricing_elite_desc: 'للأندية التي تريد تحكمًا متقدمًا وهوية مخصصة وأدوات ذكاء اصطناعي.',
  landing_pkg_feature_ml_advanced: 'تحليلات متقدمة بمساعدة ML لاتجاهات الأداء الرئيسية',
  landing_cta_title: 'امنح ناديك نظامًا واحدًا للأعضاء والملاعب والمباريات والرؤى.',
  landing_cta_desc: 'ابدأ بتشغيل أكثر تنظيمًا وقلّل الاحتكاك الإداري وامنح اللاعبين والمدربين وإدارة النادي تجربة أكثر احترافية من اليوم الأول.',
  landing_cta_button: 'أنشئ ناديك',
  landing_contact_badge: 'تواصل معنا',
  landing_contact_title: 'دعنا نحدد الإعداد المناسب لناديك.',
  landing_contact_desc: 'سواء كنت تطلق جهة جديدة، أو تستبدل أعمالًا إدارية متفرقة، أو تريد تنظيمًا أفضل للأعضاء والملاعب والتقارير والتحليلات، يمكننا مساعدتك في اختيار الباقة وطريقة الإطلاق المناسبة.',
  landing_contact_best_fit_title: 'الأنسب لـ',
  landing_contact_best_fit_desc: 'الأندية التي تريد نظام تشغيل أكثر تنظيمًا لإدارة الأعضاء والتحكم في الانتظار وتوزيع الملاعب والتقارير والتقييمات والرؤى.',
  landing_contact_discuss_title: 'ما الذي يمكن مناقشته',
  landing_contact_discuss_1: 'توجيه حول باقات ستارتر وبرو وإيليت',
  landing_contact_discuss_2: 'ترحيل الأعضاء ومسار الإضافة وهيكل الصلاحيات',
  landing_contact_discuss_3: 'إعداد الملاعب وقواعد الانتظار والتقارير ومسارات عمل المدربين',
  landing_footer_subtitle: 'نظام ذكاء رياضات المضرب',
  landing_footer_desc: 'يجمع Smashlytics إدارة الأعضاء وتدفق الملاعب والتقارير ورؤية الأداء في نظام واحد واضح مصمم لجهات رياضات المضرب الحديثة.',
  landing_footer_platform: 'المنصة',
  landing_footer_access: 'الوصول',
  landing_footer_signup: 'إنشاء حساب',
  landing_footer_talk: 'تحدث معنا',
  landing_footer_note: 'للأندية التي تخطط لنموذج تشغيل أكثر تنظيمًا.',
  landing_footer_copyright: '© {{year}} Smashlytics. مصمم لجهات رياضات المضرب الحديثة.',
  first_login_password_set_success: 'تم تعيين كلمة المرور بنجاح. يرجى تسجيل الدخول.',
  first_login_password_set_failed: 'فشل تعيين كلمة المرور',
  } as const;

export default ar;
